<link rel="preload" href="images/my-plan-banner.png" as="image">
<div class="page-title-container flxClmn-center">
	<div class="page-title-inner-container">
		<span class="page-title">My Plan</span>
	</div>
	<div class="page-subtitle-container">
		<span class="page-subtitle">Your subscription, licenses and billing</span>
	</div>
</div>

<div class="page-inner-content-holder flxClmn bs-enabled">
	<div *ngIf="isLoaded" class="flex-row gap-4" style="max-width: 1200px;">

		<!-- sidebar -->
		<div class="flex-column gap-3 f-1-0" style="max-width: 290px;">
			<div class="flex-column border rounded-1 p-4 gap-4">
				<span class="mb-2 fw-bold" style="font-size: 1rem;">General Info</span>

				<div class="flex-row gap-2 align-items-center">
					<i class="fas fa-shield-alt text-muted" style="font-size: 1.1rem;"></i>
					<div class="flex-column gap-1">
						<span class="fw-bold" style="font-size: 15px;">Current Plan</span>
						<div class="text-capitalize" [ngClass]="accountInfo.plan.plan === dic.CONSTANTS.planTypePro ? 'badge text-bg-success text-white fs-6' : 'text-muted'">
							{{accountInfo.plan.plan}}
						</div>
					</div>
				</div>
				<div class="flex-row gap-2 align-items-center">
					<i class="far fa-user text-muted" style="font-size: 1.1rem;"></i>
					<div class="flex-column gap-1">
						<span class="fw-bold" style="font-size: 15px;">Level</span>
						<div class="text-capitalize text-muted">
							{{accountInfo.user_role === dic.CONSTANTS.userRole.subAdmin ? dic.CONSTANTS.userRole.admin : accountInfo.user_role}}
						</div>
					</div>
				</div>
				<div class="flex-row gap-2 align-items-center">
					<i class="far fa-calendar-alt text-muted" style="font-size: 1.1rem;"></i>
					<div class="flex-column gap-1">
						<span class="fw-bold" style="font-size: 15px;">Plan Expiration</span>
						<span [ngClass]="daysLeftUntilExpiration < 365/4 && accountInfo.plan.plan === dic.CONSTANTS.planTypePro ? 'text-danger' : 'text-muted'">
									{{accountInfo.plan.expired | date:'MM/dd/yyyy'}}

							<i class="far fa-exclamation-triangle cursor-pointer ms-1" style="font-size: 0.7rem;"
							   *ngIf="daysLeftUntilExpiration < 365/4 && accountInfo.plan.plan === dic.CONSTANTS.planTypePro"
							   tooltip="{{daysLeftUntilExpiration > 0 ? 'Plan expires in ' + daysLeftUntilExpiration + ' days. Consider extending' : 'Plan is expired. Consider renewing'}} your plan below">
								</i>
							</span>
					</div>
				</div>
				<div class="flex-row gap-2 align-items-center" *ngIf="accountInfo.plan.plan === dic.CONSTANTS.planTypePro">
					<i class="far fa-id-badge text-muted" style="font-size: 1.1rem;"></i>
					<div class="flex-column gap-1">
						<span class="fw-bold" style="font-size: 15px;">Licenses Used</span>
						<span class="text-muted" *ngIf="accountInfo.plan.threat_protection.allowed_users">
							{{accountInfo.plan.threat_protection.used_users}} of {{accountInfo.plan.threat_protection.allowed_users}} mailboxes (Inbound)
						</span>
						<span class="text-muted" *ngIf="accountInfo.plan.shared_plan.allowed_users">
							{{accountInfo.plan.shared_plan.used_users}} of {{accountInfo.plan.shared_plan.allowed_users}} users (Outbound)
						</span>
					</div>
				</div>

				<div class="flex-column gap-2" *ngIf="(accountInfo.user_role === dic.CONSTANTS.userRole.subAdmin || accountInfo.user_role === dic.CONSTANTS.userRole.user) && sharedPlanInfo.shared_plan.key">
					<hr class="mt-0"/>
					<span>
						You joined this plan with a <b>plan key</b>
						<i style="font-weight: 400;" class="far fa-question-circle ms-1" tooltip="<b>Plan key</b> is the key for the shared plan that you have joined" title-direction="right"></i>
					</span>
					<div class="flex-row align-items-center gap-2">
						<btn-c style="min-width: 0; color: gray;"
							   color="gray" variant="outlined"
							   btnTooltip="Copy the shared plan key"
							   (action)="copyKeyToClipboard(sharedPlanInfo.shared_plan.key)">
							<div class="flex-row align-items-center gap-1 copy-link">
								<i class="far fa-key"></i>
								<span class="copy-link">Copy Key</span>
							</div>
						</btn-c>
						<btn-c class="f-1-0" color="danger" variant="outlined"
							   startIcon="far fa-sign-out-alt"
							   btnTooltip="Leave this plan and go back to your previous plan"
							   (action)="leaveSharedPlan();">
							Leave Plan
						</btn-c>
					</div>
				</div>


				<div class="flex-column gap-2" *ngIf="showUpgradeOrExpandPlan">
					<!-- pro -->
					<ng-container *ngIf="accountInfo.plan.plan === dic.CONSTANTS.planTypePro && !accountInfo.plan.partner_plan_id">
						<!-- Hide "Extend" when subscription is active — it auto-renews -->
						<btn-c class="w-100"
							   *ngIf="subscriptions && !subscriptions?.length"
							   (action)="selectedUpgradePlanMethod = upgradePlanMethods.oneYear; openMakePaymentPopup();">
							Renew Annual Subscription
						</btn-c>

						<btn-c class="w-100" *ngIf="subscriptions && !subscriptions?.length"
							   (action)="selectedUpgradePlanMethod = upgradePlanMethods.licenses; openMakePaymentPopup();">
							Adjust License Count
						</btn-c>

					<!-- Subscription status & management -->
					<ng-container *ngIf="subscriptions?.length">
						<div class="flex-column gap-1 border rounded-1 p-2" style="font-size: 12px; background: rgba(0,0,0,0.02);">
							<div class="flex-row align-items-center gap-2 flex-wrap">
								<span class="badge" [ngClass]="subscriptions[0].cancel_at_period_end ? 'text-bg-warning' : 'text-bg-success'">
									{{(subscriptions[0].cancel_at_period_end && 'canceling' || subscriptions[0].status) | titlecase}}
								</span>
								<span class="text-capitalize text-muted fw-bold">
									{{subscriptions[0].items?.data?.[0]?.price?.recurring?.interval}}ly
								</span>
							</div>
							<span class="text-muted">Next charge: <b>{{getNextChargeDate(subscriptions[0]) | date:'MM/dd/yyyy'}}</b></span>
							<span class="text-muted" style="font-size: 11px;">{{getSubscriptionPriceDisplay(subscriptions[0])}}</span>
							<span class="text-warning" *ngIf="subscriptions[0].cancel_at_period_end" style="font-size: 11px;">
								<i class="far fa-exclamation-triangle me-1"></i>Access ends: {{(subscriptions[0].cancel_at || subscriptions[0].current_period_end) * 1000 | date:'MM/dd/yyyy'}}
							</span>
						</div>
						<btn-c class="w-100" variant="outlined" (action)="openManageSubscriptionPopup();">
							<i class="far fa-cog me-1"></i> Manage Subscription
						</btn-c>
						<btn-c class="w-100" variant="outlined" (action)="openCustomerPortal();">
							<i class="far fa-credit-card me-1"></i> Update Payment Method
						</btn-c>
						<btn-c class="w-100" variant="outlined" (action)="openBillingHistoryPopup();">
							<i class="far fa-file-invoice me-1"></i> Billing History
						</btn-c>
						<btn-c class="w-100" color="danger" variant="outlined"
							   *ngIf="!subscriptions[0].cancel_at_period_end"
							   (action)="openCancelSubscriptionPopup();">
							Cancel Subscription
						</btn-c>
						<btn-c class="w-100" color="success" variant="outlined"
							   *ngIf="subscriptions[0].cancel_at_period_end"
							   (action)="reactivateSubscription();">
							<i class="far fa-redo me-1"></i> Reactivate Subscription
						</btn-c>
					</ng-container>

					<!-- One-time annual payment customers (extended_by_payment, no subscription) -->
					<ng-container *ngIf="isOneTimePaymentPlan">
						<div class="flex-column gap-1 border rounded-1 p-2" style="font-size: 12px; background: rgba(0,0,0,0.02);">
							<div class="flex-row align-items-center gap-2">
								<span class="badge text-bg-secondary">One-time</span>
								<span class="text-muted fw-bold">Annual Plan</span>
							</div>
							<span class="text-muted">No recurring subscription — renew manually to extend.</span>
						</div>
						<btn-c class="w-100" variant="outlined" (action)="openBillingHistoryPopup();">
							<i class="far fa-file-invoice me-1"></i> Billing History
						</btn-c>
					</ng-container>
					</ng-container>

					<!-- free -->
					<btn-c class="w-100" startIcon="far fa-people-arrows"
						   *ngIf="accountInfo.user_role === dic.CONSTANTS.userRole.user && !sharedPlanInfo.shared_plan.key && accountInfo.type !== dic.CONSTANTS.userTypes.heroku"
						   (action)="openJoinExistingPlanPopup();">
						Join existing plan
					</btn-c>
				</div>
			</div>

			<ng-container *ngIf="!accountInfo.plan.partner_plan_id && accountInfo.plan.plan === dic.CONSTANTS.planTypeFree">
				<ng-container *ngTemplateOutlet="commercialContactUs"></ng-container>
			</ng-container>
		</div>

		<div class="f-1-0 flex-row gap-3" style="max-width: 600px;"
			 *ngIf="accountInfo.plan.partner_plan_id">
			<ng-container *ngTemplateOutlet="commercialContactUs"></ng-container>
		</div>

		<ng-template #commercialContactUs>
			<div class="flex-column gap-2 bg-light text-center border rounded-1 p-2 bg-opacity-25 pb-3"
				 *ngIf="accountInfo.user_role === dic.CONSTANTS.userRole.admin && (!accountInfo.plan.partner_plan_id || accountInfo.plan.partner_contact_email)"
				 style="font-size: 12px; border-style: dashed !important; line-height: 2; align-self: flex-start;">
				<ng-container *ngIf="!accountInfo.plan.partner_plan_id">
					<span class="fw-bold mb-1" style="font-size: 14px;">Need more than 10 licenses?</span>
					<span>We offer custom enterprise solutions with dedicated support.</span>
					<span>
							<a class="blue-link text-decoration-underline" (click)="redirectToCustomerPlan(true)">
								Contact our sales team
							</a>
							&nbsp;for volume pricing and enterprise features.
						</span>
				</ng-container>
				<ng-container *ngIf="accountInfo.plan.partner_plan_id && accountInfo.plan.partner_contact_email">
					<span class="fw-bold mb-1" style="font-size: 14px;">Need more licenses?</span>
					<span>Contact your partner admin through the following address:</span>
					<a class="blue-link text-decoration-underline" [href]="'mailto:' + accountInfo.plan.partner_contact_email">
						{{accountInfo.plan.partner_contact_email}}
					</a>
				</ng-container>
			</div>
			<div class="flex-column gap-2 bg-light border rounded-1 p-3 bg-opacity-25" style="font-size: 12px; border-style: dashed !important;"
				 *ngIf="accountInfo.plan.plan === dic.CONSTANTS.planTypePro">
				<span class="fw-bold" style="font-size: 15px;">
					<i class="far fa-headset me-2 text-primary"></i>Support & Onboarding
				</span>
				<span class="text-muted">Get up and running quickly with guided resources</span>
				<ul class="mb-1 ps-3" style="line-height: 2.2; list-style: none;">
					<li>
						<i class="far fa-book me-2 text-success" style="width: 16px;"></i>
						<a class="blue-link text-decoration-underline" href="https://docs.trustifi.com/docs" target="_blank">Step-by-step deployment guides</a>
					</li>
					<li>
						<i class="far fa-video me-2 text-success" style="width: 16px;"></i>
						<a class="blue-link text-decoration-underline"
						   [routerLink]="['/' + dic.CONSTANTS.appStates.knowledge, dic.CONSTANTS.supportPages.trainingVideos]">Training videos and best practices</a>
					</li>
					<li>
						<i class="far fa-question-circle me-2 text-success" style="width: 16px;"></i>
						<a class="blue-link text-decoration-underline"
						   [routerLink]="['/' + dic.CONSTANTS.appStates.knowledge, dic.CONSTANTS.supportPages.knowledgeBase]">Full access to our Knowledge Base</a>
					</li>
					<li>
						<i class="far fa-robot me-2 text-success" style="width: 16px;"></i>
						<a class="blue-link text-decoration-underline" href="javascript:void(0)"
						   (click)="gs.showAiAssistant = true">Chat with Trustifi AI for quick answers</a>
					</li>
				</ul>
				<div class="border-top pt-2 mt-1">
					<span class="fw-bold" style="font-size: 13px;">Need help?</span>
					<div class="text-muted">Submit a support ticket directly from the portal</div>
					<a class="blue-link text-decoration-underline"
					   [routerLink]="['/' + dic.CONSTANTS.appStates.accountDetails, dic.CONSTANTS.supportPages.tickets]"
					   [state]="{data: 'open'}">
						Contact support
					</a>
				</div>
			</div>
		</ng-template>

		<div class="flex-column f-1-0 position-relative" style="background: linear-gradient(180deg, rgba(72, 109, 181, 0.18), rgba(72, 109, 181, 0));"
			 *ngIf="!accountInfo.plan.partner_plan_id">
			<img src="images/my-plan-banner.png" style="width: 100%; height: 240px; object-fit: cover; object-position: top;" />

			<div class="position-absolute flex-column top-0 mx-3 mt-1 text-white p-2 pe-4 static-color" style="width: 350px; right: -5%; background-color: #000000cc; font-size: 12.5px; letter-spacing: 0.2px;">
				<span class="fw-bold">Our expertise, your <b style="color: #acb7ff">peace of mind</b></span>
				<br/>
				<span>Shield your business with Trustifi email security <b style="color: #acb7ff">Pro</b>.<br/> Stop phishing, avoid data leak, and stay compliant.</span>
			</div>

			<!-- SCREEN: free -->
			<div class="flex-row justify-content-center" style="margin-top: -176px;"
				 *ngIf="accountInfo.plan.plan === dic.CONSTANTS.planTypeFree">
				<div class="flex-column gap-2 bg-white rounded-3 p-4" style="z-index: 2; box-shadow: 0 0 12px #808ba2;">
					<div class="flex-row gap-2 align-items-center justify-content-center ">
						<i class="far fa-gem text-primary" style="font-size: 1.2rem;"></i>
						<span class="fw-bold" style="font-size: 1.5rem;">PRO</span>
					</div>
					<div class="flex-column gap-2" style="font-size: 15px; line-height: 2;">
						<div class="flex-row justify-content-center gap-2 align-items-baseline" style="font-size: 1rem;">
							<span class="text-muted">USD</span>
							<span class="fw-bold" style="font-size: 2rem;">99.99</span>
							<span class="text-muted">/ year</span>
						</div>
						<btn-c class="auto-height w-100 mb-3" style="height: 35px;" (action)="openMakePaymentPopup();"
							   color="#056fd2">
							Upgrade Now
						</btn-c>
						<span>
								<i class="far fa-check text-success me-2"></i>
								Inbound Threat Protection
							</span>
						<span>
								<i class="far fa-check text-success me-2"></i>
								Email Encryption
							</span>
						<span>
								<i class="far fa-check text-success me-2"></i>
								Account Takeover Protection
							</span>
						<span>
								<i class="far fa-check text-success me-2"></i>
								Domain Protection
							</span>
						<span>
								<i class="far fa-check text-success me-2"></i>
								Multi-Factor Authentication
							</span>
						<span>
								<i class="far fa-check text-success me-2"></i>
								Email Server Integration: Microsoft 365 & Google Workspace
							</span>
						<span>
								<i class="far fa-check text-success me-2"></i>
								Email Tracking
							</span>
						<span>
								<i class="far fa-check text-success me-2"></i>
								Secure File Storage: Encrypted File Sharing
							</span>
						<span>
								<i class="far fa-check text-success me-2"></i>
								Advanced Management Portal
							</span>
					</div>
				</div>
				<div class="flex-column bg-light align-self-start" style="z-index: 1; width: 200px; margin-left: -10px; margin-top: 137px;">
					<span class="fw-bold bg-white text-center d-block" style="font-size: 1.1rem; padding: 10px;">Free</span>
					<div class="flex-column text-center align-items-center" style="font-size: 15px; line-height: 2;">
						<div class="d-flex centralize border-bottom w-100" style="padding-top: 0.7rem; padding-bottom: 0.7rem;"><i class="far fa-times text-danger"></i></div>
						<div class="text-center w-100 border-bottom" style="font-size: 14px; padding-top: 0.8rem; padding-bottom: 0.4rem;">
							Limited (1 a month)
						</div>
						<div class="d-flex centralize border-bottom w-100" style="padding-top: 0.7rem; padding-bottom: 0.7rem;"><i class="far fa-times text-danger"></i></div>
						<div class="d-flex centralize border-bottom w-100" style="padding-top: 0.7rem; padding-bottom: 0.7rem;"><i class="far fa-times text-danger"></i></div>
						<div class="d-flex centralize border-bottom w-100" style="padding-top: 0.7rem; padding-bottom: 0.7rem;"><i class="far fa-check text-success"></i></div>
						<div class="d-flex centralize border-bottom w-100" style="padding-top: 0.7rem; padding-bottom: 0.7rem;"><i class="far fa-times text-danger"></i></div>
						<div class="d-flex centralize border-bottom w-100" style="padding-top: 0.7rem; padding-bottom: 0.7rem;"><i class="far fa-check text-success"></i></div>
						<div class="d-flex centralize border-bottom w-100" style="padding-top: 0.7rem; padding-bottom: 0.7rem;"><i class="far fa-check text-success"></i></div>
						<div class="d-flex centralize w-100" style="padding-top: 0.7rem; padding-bottom: 0.7rem;"><i class="far fa-times text-danger"></i></div>
					</div>
				</div>
			</div>

			<!-- SCREEN: Pro -->
			<div class="f-1-0 flex-row justify-content-between gap-3 p-4 bg-white bg-opacity-75" *ngIf="accountInfo.plan.plan === dic.CONSTANTS.planTypePro">
				<div class="flex-column gap-3">
					<h5 class="m-0">Your Plan: <span class="text-success fw-bold">Pro</span></h5>

					<table class="simpleDataTable m-2" style="table-layout: fixed; align-self: flex-start;">
						<tr>
							<td style="width: 300px;">Encrypted & Secure Emails</td>
							<td><span class="fw-bold">Unlimited</span></td>
						</tr>
						<tr>
							<td>Email Tracking</td>
							<td><span class="fw-bold">Unlimited</span></td>
						</tr>
						<tr>
							<td>Outlook / Google Add-in</td>
							<td><i class="far fa-check text-success" style="font-size: 1rem;"></i></td>
						</tr>
						<tr>
							<td>Full Inbound Email Protection</td>
							<td><span class="text-muted" style="font-size: 0.85rem;">Use the add-in or <a href="https://trustifi.com/get-a-quote/" target="_blank" class="link-primary text-decoration-underline">contact us</a></span></td>
						</tr>
						<tr>
							<td>Outbound Management</td>
							<td><span class="text-muted" style="font-size: 0.85rem;">Manage your users</span></td>
						</tr>
						<tr>
							<td>Archive</td>
							<td>
								<i class="far fa-check text-success" style="font-size: 1rem;"
								   *ngIf="gs.userInfo?.plan?.archive?.wa_enabled"></i>
								<a href="https://trustifi.com/get-a-quote/" target="_blank" class="link-primary text-decoration-underline"
								   *ngIf="!gs.userInfo?.plan?.archive?.wa_enabled">Get a quote</a>
							</td>
						</tr>
						<tr>
							<td>Threat Simulation</td>
							<td>
								<i class="far fa-check text-success" style="font-size: 1rem;"
								   *ngIf="gs.userInfo?.plan?.archive?.wa_enabled"></i>
								<a href="https://trustifi.com/get-a-quote/" target="_blank" class="link-primary text-decoration-underline"
								   *ngIf="!gs.userInfo?.plan?.archive?.wa_enabled">Get a quote</a>
							</td>
						</tr>
					</table>
				</div>
				<div class="f-1-0 flex-column gap-2" style="max-width: 280px;">
					<ng-container *ngTemplateOutlet="commercialContactUs"></ng-container>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="!isLoaded" class="w-100 h-100 flex-row centralize">
		<loader></loader>
	</div>
</div>

<!--Join Existing Plan Popup-->
<popup-c class="bs-enabled" *ngIf="joinExistingPlanPopup?.show"
		 head="Join Existing Plan" size="dynamic"
		 (closeCb)="joinExistingPlanPopup = null;"
		 (confirmCb)="joinExistingPlanPopup?.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Join', loading: joinExistingPlanPopup.loading}}">
	<div class="flex-column f-1-0 gap-3" style="overflow: auto;">
		<span>Enter the plan key you recieved to join the plan:</span>
		<input style="width: 275px; text-overflow: clip;" type="text"
			   id="planJoinKey"
			   [(ngModel)]="joinExistingPlanPopup.key"
			   (keyup.enter)="joinSharedPlan(joinExistingPlanPopup.key)"
			   [name]="'pKey' + random"
			   placeholder="Enter key here">
	</div>
</popup-c>

<!--Upgrade / Extend Plan Popup-->
<popup-c class="bs-enabled no-content-padding" *ngIf="makePaymentPopup?.show"
		 [head]="makePaymentPopup.title"
		 size="large" width="1200px"
		 (closeCb)="makePaymentPopup = null; couponCodeModel = '';">
	<div class="flex-column f-1-0 gap-3 my-plan-payment-popup-bg" style="overflow: auto;">
		<div class="flex-column p-4 w-50 bg-white align-self-end" style="font-size: 14px;"
			 *ngIf="accountInfo.plan.plan === dic.CONSTANTS.planTypePro">
			<div class="flex-row align-items-center gap-3 mb-3">
				<i class="far fa-info-circle text-info" style="font-size: 1.2rem;"></i>
				<span *ngIf="selectedUpgradePlanMethod === upgradePlanMethods.oneYear">Please note: for this renewal you can adjust or keep the current license count. Your plan will convert to an annual recurring subscription.</span>
				<span *ngIf="selectedUpgradePlanMethod === upgradePlanMethods.licenses">Please note: the following will keep the current expiration period for your plan, and will update your plan's total license count within your current expiration date ({{accountInfo.plan.expired | date:'MM/dd/yyyy'}}).</span>
			</div>
			<!-- extend plan expiration -->
			<div class="flex-column gap-3" style="min-height: fit-content;" *ngIf="selectedUpgradePlanMethod === upgradePlanMethods.oneYear">
				<div class="flex-row align-items-center flex-shrink-0 gap-1">
					<span style="flex-basis: 310px;">Your plan’s current total licenses:</span>
					<b style="font-size: 0.95rem;">{{currentLicenses}}</b>
				</div>
				<!-- CC: taken from my-plan.component.html -> add licenses section -->
				<div class="flex-row align-items-center flex-shrink-0 gap-1">
					<span style="flex-basis: 310px;">Select how many licenses you want to have for this period:</span>
					<input type="number" min="1" pattern="^([1-9][0-9]*)$"
						   [(ngModel)]="amountOfUsersToAdd" class="ps-2" style="flex-basis: 90px; min-width: 0;">
				</div>
				<div class="flex-row align-items-center flex-shrink-0 gap-1">
					<span style="flex-basis: 310px;">Your plan’s current expiration date:</span>
					<b style="font-size: 0.95rem;">{{accountInfo.plan.expired | date:'MM/dd/yyyy'}}</b>
				</div>
				<div class="flex-row align-items-center flex-shrink-0 gap-1">
					<span style="flex-basis: 310px;">Your plan's new expiration date will be:</span>
					<b class="text-success" style="font-size: 0.95rem;">{{oneYearAheadOfExpiration | date:'MM/dd/yyyy'}}</b>
				</div>
				<ng-container *ngTemplateOutlet="couponInput"></ng-container>
			</div>

			<!-- add licenses -->
			<div class="flex-column gap-3" style="min-height: fit-content;" *ngIf="selectedUpgradePlanMethod === upgradePlanMethods.licenses">
				<div class="flex-row align-items-center flex-shrink-0 gap-1">
					<span style="flex-basis: 310px;">Your plan’s current total licenses:</span>
					<b style="font-size: 0.95rem;">{{currentLicenses}}</b>
				</div>
				<div class="flex-row align-items-center flex-shrink-0 gap-1">
					<span style="flex-basis: 310px;">Select how many licenses you want to have for this period:</span>
					<input type="number" min="1" pattern="^([1-9][0-9]*)$"
						   [(ngModel)]="amountOfUsersToAdd" class="ps-2" style="flex-basis: 90px; min-width: 0;">
				</div>
				<div class="flex-row align-items-center flex-shrink-0 gap-1">
					<span style="flex-basis: 310px;">Your plan’s current expiration date:</span>
					<b style="font-size: 0.95rem;">{{accountInfo.plan.expired | date:'MM/dd/yyyy'}}</b>
				</div>

				<ng-container *ngTemplateOutlet="couponInput"></ng-container>
			</div>

			<stripe-buttons-component
				[hasAccessToken]="true"
				[type]="selectedUpgradePlanMethod.paypalPaymentType"
				[partner]="partner"
				[couponCode]="couponCode"
				[numUsers]="amountOfUsersToAdd"
				[accountDetails]="userInfo"
				[priceId]="selectedPrice?.id"
				(onComplete)="paymentComplete($event.err, $event.res)">
			</stripe-buttons-component>
		</div>

		<!--free user buys plan-->
		<div class="flex-row f-1-0 overflow-auto" *ngIf="accountInfo.plan.plan === dic.CONSTANTS.planTypeFree">
			<div class="flex-row f-1-0 position-relative">
				<div class="flex-column my-2 position-relative align-self-center" style="margin-left: 4vw; height: 85%">
					<div class="flex-column f-1-0 gap-3 bg-white p-5 shadow position-relative" style="z-index: 5;">
						<h6>By purchasing Pro you get:</h6>
						<div class="flex-column f-1-0 justify-content-evenly" style="font-size: 15px;">
							<span><i class="far fa-check text-success me-2"></i>Inbound Threat Protection</span>
							<span><i class="far fa-check text-success me-2"></i>Email Encryption</span>
							<span><i class="far fa-check text-success me-2"></i>Account Takeover Protection</span>
							<span><i class="far fa-check text-success me-2"></i>Domain Protection</span>
							<span><i class="far fa-check text-success me-2"></i>Multi-Factor Authentication</span>
							<span><i class="far fa-check text-success me-2"></i>Email Server Integration: Microsoft 365 & Google Workspace</span>
							<span><i class="far fa-check text-success me-2"></i>Email Tracking</span>
							<span><i class="far fa-check text-success me-2"></i>Secure File Storage: Encrypted File Sharing</span>
							<span><i class="far fa-check text-success me-2"></i>Advanced Management Portal</span>
						</div>
					</div>

					<div class="position-absolute bg-white opacity-25 w-100 h-100" style="top: -10px;left: -10px;"></div>
					<div class="position-absolute w-100 h-100" style="top: 8px; right: -10px; background-color: #ffffff54;"></div>
				</div>
			</div>

			<div class="flex-column f-1-0 gap-2 overflow-auto p-3" *ngIf="accountInfo.plan.plan === dic.CONSTANTS.planTypeFree">
				<div class="flex-column gap-1 align-items-center flex-shrink-0 px-4" style="min-height: fit-content;"
					 *ngIf="partner && partner.displayName">
					<img *ngIf="partner.logo" [src]="partner.logo" style="max-width: 130px;">
					<span>Via Partner <b>{{partner.displayName}}</b></span>
				</div>
				<div class="flex-column gap-2 px-4" style="min-height: fit-content; font-size: 14px;">
					<div class="flex-row align-items-center flex-shrink-0 gap-1 gap-2">
						<span>Select how many new licenses to buy per year (up to {{partner.maxUsers || 20}}):</span>
						<input type="number" min="1" pattern="^([1-9][0-9]*)$"
							   [(ngModel)]="amountOfUsersToAdd" (keyup)="correctFreeUserAmountToAddInput()" class="ps-2" style="min-width: 60px; flex: 0 1;">
					</div>

					<span *ngIf="payments.trustifi" class="blue-link text-decoration-underline cursor-pointer" (click)="redirectToCustomerPlan(true);">{{partner ? 'Need more users? Get a quote now!': 'Want to upgrade? Get a quote now!'}}</span>
					<span *ngIf="!payments.trustifi && payments.buttonName && payments.redirectUrl" class="blue-link text-decoration-underline cursor-pointer" (click)="redirectToCustomerPlan();">{{payments.buttonName}}</span>

					<ng-container *ngTemplateOutlet="couponInput"></ng-container>
				</div>

				<stripe-buttons-component
					[hasAccessToken]="true"
					[type]="dic.CONSTANTS.paypalPaymentType.upgradePro"
					[partner]="partner"
					[couponCode]="couponCode"
					[numUsers]="amountOfUsersToAdd"
					[accountDetails]="userInfo"
					[priceId]="selectedPrice?.id"
					(onComplete)="paymentComplete($event.err, $event.res)">
				</stripe-buttons-component>

			</div>
		</div>
	</div>
</popup-c>

<!--((coupon template))-->
<ng-template #couponInput>
	<div class="flex-row justify-content-end">
		<div class="flex-row gap-2 pt-3 align-items-center f-1-0" *ngIf="!isCouponApplied">
			<span>Enter coupon code:</span>
			<input type="text"
				   [disabled]="isCouponApplied"
				   (keyup.enter)="applyCoupon()"
				   [ngClass]="{'disabled bg-transparent fw-bold border-0 opacity-100 f-1-0' : isCouponApplied}"
				   [(ngModel)]="couponCodeModel" style="width: 100px;">
			<btn-c style="min-width: 0;"
				   *ngIf="!isCouponApplied"
				   endIcon="zmdi zmdi-check"
				   (action)="applyCoupon()">
			</btn-c>
			<span class="text-success fw-500" *ngIf="isCouponApplied">${{priceSaved}} off per license</span>
		</div>
	</div>
</ng-template>
<!---->

<!--Cancel Subscription Popup-->
<popup-c class="bs-enabled" *ngIf="cancelSubscriptionPopup?.show"
		 head="Cancel Subscription" size="dynamic"
		 (closeCb)="cancelSubscriptionPopup = null;"
		 [buttons]="{cancel: 'Keep Subscription', confirm: {text: 'Confirm Cancellation', loading: cancelSubscriptionPopup.loading}}"
		 (confirmCb)="confirmCancelSubscription()">
	<div class="flex-column f-1-0 gap-3" style="overflow: auto; min-width: 380px;">
		<div class="flex-row gap-2 p-3 rounded-1 border" style="background: rgba(255,193,7,0.08); border-color: rgba(255,193,7,0.4) !important;">
			<i class="far fa-exclamation-triangle text-warning mt-1"></i>
			<div class="flex-column gap-1" style="font-size: 13px;">
				<span class="fw-bold">Your subscription will stay active until:</span>
				<span class="fw-bold text-success">{{cancelSubscriptionPopup.subscription.current_period_end * 1000 | date:'MMMM d, yyyy'}}</span>
				<span class="text-muted">After this date your plan reverts to Free. No further charges will be made.</span>
			</div>
		</div>
		<div class="flex-column gap-2">
			<label class="fw-bold">Reason for canceling:</label>
			<app-dropdown-c style="width: 100%;" text="{{getCancelFeedbackLabel()}}">
				<li *ngFor="let option of cancelFeedbackOptions"
					(click)="cancelSubscriptionPopup.feedback = option.value">
					{{option.label}}
				</li>
			</app-dropdown-c>
		</div>
		<div class="flex-column gap-2">
			<label>Additional comments <span class="text-muted fw-normal">(optional)</span>:</label>
			<textarea rows="3" style="width: 100%; resize: none; border-radius: 4px; border: 1px solid #ccc; padding: 6px;"
					  [(ngModel)]="cancelSubscriptionPopup.comment"
					  placeholder="Help us improve — tell us more..."></textarea>
		</div>
	</div>
</popup-c>

<!--Manage Subscription Popup-->
<popup-c class="bs-enabled" *ngIf="manageSubscriptionPopup?.show"
		 head="Manage Subscription" size="dynamic"
		 (closeCb)="manageSubscriptionPopup = null;"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Update Seats', loading: manageSubscriptionPopup.loading}}"
		 (confirmCb)="updateSubscriptionSeats()">
	<div class="flex-column f-1-0 gap-3" style="overflow: auto; min-width: 400px;">
		<div class="flex-column gap-2 border rounded-1 p-3" style="background: rgba(0,0,0,0.02); font-size: 13px;">
			<span class="fw-bold mb-1">Current Subscription</span>
			<div class="flex-row gap-4 flex-wrap">
				<div class="flex-column gap-1">
					<span class="text-muted">Status</span>
					<span class="badge" [ngClass]="manageSubscriptionPopup.subscription.cancel_at_period_end ? 'text-bg-warning' : 'text-bg-success'">
						{{(manageSubscriptionPopup.subscription.cancel_at_period_end && 'canceling' || manageSubscriptionPopup.subscription.status) | titlecase}}
					</span>
				</div>
				<div class="flex-column gap-1">
					<span class="text-muted">Billing</span>
					<span class="text-capitalize fw-bold">{{manageSubscriptionPopup.subscription.items?.data?.[0]?.price?.recurring?.interval}}ly</span>
				</div>
				<div class="flex-column gap-1">
					<span class="text-muted">Next Charge</span>
					<span class="fw-bold">{{getNextChargeDate(manageSubscriptionPopup.subscription) | date:'MM/dd/yyyy'}}</span>
				</div>
				<div class="flex-column gap-1">
					<span class="text-muted">Current Seats</span>
					<span class="fw-bold">{{manageSubscriptionPopup.currentSeats}}</span>
				</div>
			</div>
		</div>
		<div class="flex-column gap-2">
			<label class="fw-bold">Update number of seats:</label>
			<div class="flex-row align-items-center gap-2">
				<input type="number" min="1" class="ps-2" style="width: 90px; border: 1px solid #ccc; border-radius: 4px; height: 34px;"
					   [(ngModel)]="manageSubscriptionPopup.newSeats"
					   (change)="previewSeatChange()">
				<span class="text-muted" style="font-size: 13px;">
					@ ${{(manageSubscriptionPopup.subscription.items?.data?.[0]?.price?.unit_amount / 100).toFixed(2)}} / seat / {{manageSubscriptionPopup.subscription.items?.data?.[0]?.price?.recurring?.interval}}
				</span>
			</div>
			<span class="text-muted" style="font-size: 12px;"><i class="far fa-info-circle me-1"></i>Proration is applied automatically for mid-cycle changes.</span>
			<div class="flex-row align-items-center gap-2 pt-1" style="font-size: 13px;" *ngIf="manageSubscriptionPopup.previewLoading">
				<loader style="transform: scale(0.5);"></loader><span class="text-muted">Calculating proration...</span>
			</div>
			<div class="flex-row align-items-center gap-2 rounded-1 p-2 border" style="font-size: 13px; background: rgba(0,128,0,0.05);"
				 *ngIf="manageSubscriptionPopup.previewAmount !== null && !manageSubscriptionPopup.previewLoading">
				<i class="far fa-receipt text-success"></i>
				<span>Due now (prorated): <b class="text-success">${{(manageSubscriptionPopup.previewAmount / 100).toFixed(2)}}</b></span>
			</div>
		</div>
		<div class="flex-row align-items-center gap-2 pt-2 border-top" style="font-size: 13px;">
			<i class="far fa-credit-card text-muted"></i>
			<span>To change payment method or billing interval, use the
				<span class="blue-link text-decoration-underline cursor-pointer" (click)="openCustomerPortal()">billing portal</span>.
			</span>
		</div>
	</div>
</popup-c>

<!--Billing History Popup-->
<popup-c class="bs-enabled" *ngIf="billingHistoryPopup?.show"
		 head="Billing History" size="large"
		 (closeCb)="billingHistoryPopup = null;">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto; min-width: 500px;">
		<div *ngIf="!invoicesLoaded" class="flex-row centralize p-4">
			<loader></loader>
		</div>
		<ng-container *ngIf="invoicesLoaded">
			<span class="text-muted p-2" *ngIf="!invoices?.length">No billing history found.</span>
			<table class="simpleDataTable w-100" *ngIf="invoices?.length">
				<thead>
					<tr>
						<th>Date</th>
						<th>Description</th>
						<th>Amount</th>
						<th>Status</th>
						<th>Invoice</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let invoice of invoices">
						<td>{{invoice.created * 1000 | date:'MM/dd/yyyy'}}</td>
						<td style="max-width: 240px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
							{{invoice.lines?.data?.[0]?.description || invoice.number}}
						</td>
						<td>${{(invoice.amount_paid / 100).toFixed(2)}} {{invoice.currency?.toUpperCase()}}</td>
						<td>
							<span class="badge"
								  [ngClass]="invoice.status === 'paid' ? 'text-bg-success' : invoice.status === 'open' ? 'text-bg-warning' : 'text-bg-secondary'">
								{{invoice.status | titlecase}}
							</span>
						</td>
						<td class="flex-row gap-2">
							<a *ngIf="invoice.hosted_invoice_url" [href]="invoice.hosted_invoice_url" target="_blank" class="blue-link text-decoration-underline">
								<i class="far fa-external-link-alt me-1"></i>View
							</a>
							<a *ngIf="invoice.invoice_pdf" [href]="invoice.invoice_pdf" target="_blank" class="blue-link text-decoration-underline ms-2">
								<i class="far fa-file-pdf me-1"></i>PDF
							</a>
						</td>
					</tr>
				</tbody>
			</table>
		</ng-container>
	</div>
</popup-c>
